<script>
export default {
  name: 'ProjectInvite',
  async created () {
    const token = this.$route.params.token
    const projectFromRoute = this.$route.query?.project
    const projectFromSearch = new URLSearchParams(window.location.search).get('project')
    const project = Array.isArray(projectFromRoute) ? projectFromRoute[0] : (projectFromRoute || projectFromSearch)

    const {data} = await axios.put('api/auth/project-member/accept-invitation', {
      token,
      project
    })

    await window.open(`/?auth_token=${data?.data}`, '_self')
  }
}
</script>

<template>
  <div />
</template>
